/** Recovery reads belong to the visible chat. Hidden tabs retain their durable
 * receipts and catch up on return instead of competing for browser connections. */
export function startVisibleRecoveryLoop(options:{
  isCurrent:()=>boolean;
  read:()=>Promise<number|void>;
  document:Pick<Document,'visibilityState'|'addEventListener'|'removeEventListener'>;
  delay?:number;
  setTimer?:typeof setTimeout;
  clearTimer?:typeof clearTimeout;
}){
  const schedule=options.setTimer??setTimeout,cancel=options.clearTimer??clearTimeout;
  let stopped=false,reading=false,wakeDuringRead=false,timer:ReturnType<typeof setTimeout>|undefined;
  const current=()=>!stopped&&options.isCurrent();
  const clear=()=>{if(timer!==undefined){cancel(timer);timer=undefined;}};
  const poll=async()=>{
    if(!current()||reading||options.document.visibilityState==='hidden')return;
    clear();reading=true;let delay=options.delay??3000;
    try{const next=await options.read();if(typeof next==='number'&&Number.isFinite(next)&&next>0)delay=next;}
    catch{/* Keep existing content; retry the read, never provider work. */}
    finally{reading=false;if(wakeDuringRead)delay=Math.min(delay,options.delay??3000);wakeDuringRead=false;if(current()&&options.document.visibilityState!=='hidden')timer=schedule(()=>{void poll();},delay);}
  };
  const visible=()=>{clear();if(options.document.visibilityState!=='hidden'){if(reading)wakeDuringRead=true;else void poll();}};
  options.document.addEventListener('visibilitychange',visible);
  void poll();
  return Object.assign(()=>{stopped=true;clear();options.document.removeEventListener('visibilitychange',visible);},{wake:visible});
}
